import { render, staticRenderFns } from "./ShopSearchHistory.vue?vue&type=template&id=9112db9a&scoped=true"
import script from "./ShopSearchHistory.vue?vue&type=script&lang=ts"
export * from "./ShopSearchHistory.vue?vue&type=script&lang=ts"
import style0 from "./ShopSearchHistory.vue?vue&type=style&index=0&id=9112db9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9112db9a",
  null
  
)

export default component.exports